/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { Token } from '../models/token';
import { ExtendedLoginRequest } from '../models/extended-login-request';
@Injectable({
  providedIn: 'root',
})
class ApiTokenService extends __BaseService {
  static readonly ApiTokenCreatePath = '/api-token';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Creates JSON Web Token for authorization
   * @param loginRequest Model with Username and Password of the user
   * @return OK
   */
  ApiTokenCreateResponse(loginRequest: ExtendedLoginRequest): __Observable<__StrictHttpResponse<Token>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = loginRequest;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api-token`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Token>;
      })
    );
  }
  /**
   * Creates JSON Web Token for authorization
   * @param loginRequest Model with Username and Password of the user
   * @return OK
   */
  ApiTokenCreate(loginRequest: ExtendedLoginRequest): __Observable<Token> {
    return this.ApiTokenCreateResponse(loginRequest).pipe(
      __map(_r => _r.body as Token)
    );
  }
}

namespace ApiTokenService {
}

export { ApiTokenService }